@if (user) {
  <app-user-form
    [user]="user"
    action="{{ 'edit' | translate }}"
    (close)="closeForm($event)">
  </app-user-form>
}
